import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "onboarding-tooltips"
}

import { onMounted, ref } from 'vue'
import Tooltip from '@/components/onboarding/Tooltip.vue'
import { Placement } from '@popperjs/core'
import { useEndUserProfileStore } from '@/store/user-profile'
import { usePersistedStorage } from '@/composables/UsePersistedStorage'

interface TooltipModel {
  referenceElementId: string
  text: string,
  placement: Placement
  confirmText: string,
  offset?: number,
  width?: number,
  paddingRight?: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingTooltips',
  setup(__props) {

const userStore = useEndUserProfileStore()
const { persistedStorage } = usePersistedStorage()

const tooltipStorageKey = `onboarding.tooltips.completed.${userStore.userId}`
const tooltipsCompleted = ref(persistedStorage.getItem(tooltipStorageKey) === 'true')
const tooltipIndex = ref(-1)

const nextTooltip = () => {
  tooltipIndex.value++
  if (tooltipIndex.value >= tooltips.length) {
    closeTooltips()
  }
}
const ifReferenceElementExist = (id: string) => document.getElementById(id)

const closeTooltips = () => {
  tooltipsCompleted.value = true
  persistedStorage.setItem(tooltipStorageKey, 'true')
}

const tooltips: TooltipModel[] = [
  {
    referenceElementId: 'muteToggle',
    text: 'Turn sound off and change tracks here',
    placement: 'top',
    confirmText: 'Next',
    width: 160,
    paddingRight: 20
  },
  {
    referenceElementId: 'orientationSwitcher',
    text: 'Choose the size of your video here',
    placement: 'top',
    confirmText: 'Next',
    offset: 70
  },
  {
    referenceElementId: 'actionMenu',
    text: 'Find royalty-free content, text and effects here',
    placement: 'left',
    confirmText: 'Next',
    width: 169
  },
  {
    referenceElementId: 'exportButton',
    text: 'When you’re done, hit export to render your video in the chosen size',
    placement: 'top',
    confirmText: 'Okay',
    offset: -32,
    width: 220
  }
]

onMounted(() => {
  tooltipIndex.value++
})


return (_ctx: any,_cache: any) => {
  return (!tooltipsCompleted.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tooltips, (tooltipModel, index) => {
          return _withDirectives(_createVNode(Tooltip, {
            key: index,
            text: tooltipModel.text,
            "reference-element-id": tooltipModel.referenceElementId,
            "arrow-position": tooltipModel.arrowPosition,
            placement: tooltipModel.placement,
            "confirm-text": tooltipModel.confirmText,
            isActive: tooltipIndex.value === index,
            offset: tooltipModel.offset,
            width: tooltipModel.width,
            paddingRight: tooltipModel.paddingRight,
            "is-onboarding": true,
            onNext: nextTooltip,
            onClose: closeTooltips
          }, null, 8, ["text", "reference-element-id", "arrow-position", "placement", "confirm-text", "isActive", "offset", "width", "paddingRight"]), [
            [_vShow, ifReferenceElementExist(tooltipModel.referenceElementId)]
          ])
        }), 64))
      ]))
    : _createCommentVNode("", true)
}
}

})